import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';

export const ButtonRect = styled.rect<{ xPos: number; yPos: number; isRightBtn?: boolean; }>`
    width: 100%;
    height: ${rem(52)};
`;
